"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCREEN_SHARE_STATUS = void 0;
/**
 * Application-level lifecycle states for the local screen share.
 * Agora connection states such as CONNECTING and DISCONNECTING are tracked
 * separately on the screen share client.
 */
var SCREEN_SHARE_STATUS = exports.SCREEN_SHARE_STATUS = {
  // No local screen share is active.
  IDLE: 'IDLE',
  // A local screen share start has been requested and is still in progress.
  STARTING: 'STARTING',
  // The local screen share started successfully and is active.
  ACTIVE: 'ACTIVE'
};